<template>
  <div style="margin: 20px; margin-left: 0px;">
    <el-form ref="xForm" :model="form">
      <el-form-item prop="name">
        <el-card class="box-card">
          <div slot="header">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-input
                  v-model="autoData.vehicleLicenseNumber"
                  placeholder="请输入车牌号"
                  clearable
                />
              </el-col>

              <el-col :span="6">
                <el-input
                  v-model="autoData.phone"
                  placeholder="请输入联系电话"
                  clearable
                  max-length="11"
                />
              </el-col>
              <el-col :span="6">
                <el-button type="primary" @click="driverListForShipTeam2Api">
                  查询
                </el-button>
                <el-button @click="clearNewData">
                  清空
                </el-button>
              </el-col>
            </el-row>
            <div v-if="tempData" class="driver_info_box">
              <div
                v-for="item in tempData"
                :key="item.partyCode"
                style="display: flex;align-items: center;"
              >
                <p>
                  <span>车牌号：{{ item.vehicleLicenseNumber }}</span>
                </p>
                <p>
                  <span>实际承运人或车队名：{{ item.name }}</span>
                </p>
                <p>
                  <span>联系电话：{{ item.phone }}</span>
                </p>
                <el-button
                  style="height:35px;"
                  size="small"
                  @click="insertNewData(item)"
                >
                  新增
                </el-button>
              </div>
            </div>
          </div>
          <vxe-table
            ref="xTable"
            resizable
            border
            highlight-hover-row
            :data="tableData"
            height="380"
          >
            <vxe-table-column field="name" title="实际承运人姓名" />
            <vxe-table-column
              field="phone"
              title="实际承运人手机号"
              min-width="150"
            >
              <template #default="{ row }">
                {{ maskPhone(row.phone) }}
              </template>
            </vxe-table-column>
            <vxe-table-column field="vehicleLicenseNumber" title="车牌号" />
            <!-- <vxe-table-column field="phone" title="联系电话" /> -->
            <vxe-table-column field="vehicleLoadStatusName" title="负载状态" />
            <vxe-table-column title="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <el-button
                    type="text"
                    @click="funcDelete(scope.row.partyCode)"
                  >
                    <i class="el-icon-delete" />
                  </el-button>
                </el-tooltip>
              </template>
            </vxe-table-column>
          </vxe-table>
        </el-card>
      </el-form-item>
      <el-form-item>
        <div style="text-align: right;">
          <el-button @click="funcCancel">
            取 消
          </el-button>
          <el-button type="primary" @click="funcSubmit">
            确 定
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { createDriverForRepeatGroup } from "@/api/orderform";
import { addOrUpdateVehicleTeam, driverListForShipTeam2 } from "@/api/shipment";
export default {
  name: "VehicleTeamAdd",
  props: {
    shipmentPartyCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      partyCode: "",
      form: {
        driverCodes: []
      },
      tempData: null,
      autoData: {
        vehicleLicenseNumber: "",
        name: "",
        phone: ""
      },
      driverInfo: null
    };
  },
  created() {
    this.partyCode = this.$route.query.partyCode
      ? this.$route.query.partyCode
      : this.shipmentPartyCode;
  },
  methods: {
    maskPhone(phone) {
      if (!phone) return "";
      const phoneStr = phone.toString();
      if (phoneStr.length === 11) {
        // 11位手机号：显示前3位和后4位，中间4位用*替换
        return phoneStr.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else if (phoneStr.length >= 7) {
        // 其他长度的电话号码：保留前3位和后4位，中间用*替换
        const start = phoneStr.substring(0, 3);
        const end = phoneStr.substring(phoneStr.length - 4);
        const middle = "*".repeat(phoneStr.length - 7);
        return start + middle + end;
      }
      return phoneStr; // 长度不足7位的直接返回原值
    },
    driverListForShipTeam2Api() {
      if (!this.autoData.vehicleLicenseNumber && !this.autoData.phone) {
        this.$message({ message: "请输入车牌号或联系电话！", type: "error" });
        return;
      }
      // 正则校验是否为正确的联系手机号
      if (
        this.autoData.phone &&
        !/^1[3456789]\d{9}$/.test(this.autoData.phone)
      ) {
        this.$message({ message: "请输入正确的联系手机号！", type: "error" });
        return;
      }
      driverListForShipTeam2({
        vehicleLicenseNumber: this.autoData.vehicleLicenseNumber,
        phone: this.autoData.phone
      }).then(res => {
        if (res.status === 0 && res.data.records.length) {
          this.tempData = res.data.records;
        } else {
          this.$message({ message: "未查询到相关实际承运人！", type: "error" });
        }
      });
    },
    // 清空
    clearNewData() {
      this.tempData = null;
      this.autoData.vehicleLicenseNumber = "";
      this.autoData.name = "";
      this.autoData.phone = "";
    },
    // 新增实际承运人
    insertNewData(item) {
      if (this.tempData) {
        var data = JSON.parse(JSON.stringify(item));
        // this.tempData = null;
        // 检测是否有重复项
        if (this.form.driverCodes.indexOf(data.partyCode) > -1) {
          this.$message({
            message: "该实际承运人已存在，不能重复添加！",
            type: "warning"
          });
        } else {
          this.form.driverCodes.unshift(data.partyCode);
          this.tableData.unshift(data);
        }
        this.autoData.vehicleLicenseNumber = "";
        this.autoData.name = "";
        this.autoData.phone = "";
      } else {
        this.$message({ message: "请选择实际承运人！", type: "error" });
      }
    },
    // 删除
    funcDelete(partyCode) {
      var index = this.form.driverCodes.indexOf(partyCode);
      if (index > -1) {
        this.form.driverCodes.splice(index, 1);
      }
      this.tableData = this.tableData.filter(item => {
        return item.partyCode !== partyCode;
      });
    },
    // 模糊查询 车牌号/实际承运人姓名/联系电话
    // querySearchAsync(type, queryString, cb) {
    //   switch (type) {
    //     case "vehicle":
    //       this.autoData.vehicleLicenseNumber = queryString;
    //       var temArr1 = this.filterList();
    //       temArr1.forEach(item => {
    //         item.value = item.vehicleLicenseNumber;
    //       });
    //       cb(temArr1);
    //       break;
    //     case "name":
    //       this.autoData.name = queryString;
    //       var temArr2 = this.filterList();
    //       temArr2.forEach(item => {
    //         item.value = item.name;
    //       });
    //       cb(temArr2);
    //       break;
    //     case "phone":
    //       this.autoData.phone = queryString;
    //       var temArr3 = this.filterList();
    //       temArr3.forEach(item => {
    //         item.value = item.phone;
    //       });
    //       cb(temArr3);
    //       break;
    //   }
    // },
    // 筛选
    // filterList() {
    //   var list = this.restaurants
    //     .filter(item => {
    //       if (item.vehicleLicenseNumber) {
    //         return (
    //           item.vehicleLicenseNumber.indexOf(
    //             this.autoData.vehicleLicenseNumber
    //           ) !== -1
    //         );
    //       } else {
    //         return true;
    //       }
    //     })
    //     .filter(item => {
    //       if (item.name) {
    //         return item.name.indexOf(this.autoData.name) !== -1;
    //       }
    //     })
    //     .filter(item => {
    //       if (item.phone) {
    //         return item.phone.indexOf(this.autoData.phone) !== -1;
    //       }
    //     });
    //   return list;
    // },
    // 选中
    handleSelect(item) {
      this.tempData = item;
      this.autoData.vehicleLicenseNumber = this.tempData.vehicleLicenseNumber
        ? this.tempData.vehicleLicenseNumber
        : "";
      this.autoData.name = this.tempData.name ? this.tempData.name : "";
      this.autoData.phone = this.tempData.phone ? this.tempData.phone : "";
    },
    // 数据重置
    initData() {
      this.tempData = null;
      this.tableData = [];
      this.form = { name: "", driverCodes: [] };
      this.autoData = { vehicleLicenseNumber: "", name: "", phone: "" };
    },
    // 提交
    funcSubmit() {
      if (this.form.driverCodes.length > 0) {
        var data = Object.assign({
          driverCode: this.tableData.map(item => item.partyCode).join(",")
        });
        const rLoading = this.openLoading();
        createDriverForRepeatGroup(data).then(response => {
          rLoading.close();
          this.initData();
          this.$message({ message: response.msg, type: "success" });
          this.$emit("updateList");
        });
      } else {
        this.$message({ message: "请增加实际承运人！", type: "error" });
      }
    },
    // 取消
    funcCancel() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.driver_info_box {
  p {
    margin-right: 25px;
  }
}
.el-card {
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
  ::v-deep.el-card__header {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>

<style></style>
